import { Box, Link, Stack, Typography } from '@mui/material';
import ContactUsButton from '../contactUs/contactUsButton';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 1,
        px: 2,
        mt: 'auto',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        borderTop: '1px solid rgba(0, 0, 0, 0.08)',
      }}
    >
      <Typography variant="body2" color="text.secondary">
        {'Copyright © '}
        <Link color="inherit" href="https://www.minotii.com" target="_blank" rel="noopener noreferrer">
          www.minotii.com
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </Typography>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
        <Link
          href="https://www.minotii.com"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            fontSize: '0.875rem',
            textDecoration: 'none',
            color: 'text.secondary',
            fontWeight: 500,
            '&:hover': { color: 'primary.main' },
          }}
        >
          Website ↗
        </Link>
        <ContactUsButton label="Contact us" />
      </Box>
    </Box>
  );
};

export default Footer;
